import { BaseUriHolder } from "../utils/BaseUriHolder";
import { PublicService } from "../auth/PublicService";
import { PrivateService } from "../auth/PrivateService";


export class CompanyReviewService {
    constructor() {
        this.baseUriHolder = new BaseUriHolder();
        this.publicService = new PublicService();
        this.privateService = new PrivateService();
    }

    loadAllActiveReviews(companyId) {
        let uri = this.baseUriHolder.getPublic() + '/company/reviews/' + companyId + '/active';
        return this.publicService.getFetch(uri)
            .catch((error) => console.log("error", error));
    }

    addNewReview(reviewReq) {
        let uri = this.baseUriHolder.getJobSeeker() + '/company/review/add';
        return this.privateService.postFetch(uri, reviewReq)
        .catch((error) => console.log("error", error));
    }
}